<template>
  <div>
    <div class="brand-logo">
      <BrandLogo
        name="Theater Management"
        :logo="require('../../../assets/brands_logo_8_big.png')"
        desc="Shenzhen Orange Theaters Management Co., Ltd."
      ></BrandLogo>
    </div>
    <BrandIntro class="brand-intro" :lineArray="array"></BrandIntro>
    <div class="products">
      <div class="products__block">
        <div class="products__block__title">Theater</div>
        <img
          class="products__block__img"
          src="../../../assets/brands_image_9.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
import BrandLogo from "./BrandLogo";
import BrandIntro from "./BrandIntro"
export default {
  data() {
    return {
      array: [
          "Orange Theatre Chain, the largest theatre chain domestically",
          "Orange Theatre Chain focuses on not only performances, but also other cultural business, and experience space simultaneously",
          "Long-term resident performance"
      ]
    };
  },
  components: {
    BrandLogo,
    BrandIntro
  }
};
</script>
<style lang="scss" scoped>
.brand-logo {
  padding: 64px 0 54px 0;
  text-align: center;
}
.brand-intro{
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.products {
  height: 918px;
  background-color: #1f1f1f;
  overflow: hidden;
  &__block {
    &__title {
      color: #ec6900;
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      font-size: 26px;
      margin-top: 58px;
    }
    &__img {
      display: block;
      margin: 31px auto 0 auto;
    }
  }
}
</style>